import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';

const initialState = {
    isLoading: false,
    allLocation: [],
    addModal: false
};


// fetch the all primary diagnosis list 
export const fetchAllLocation = createAsyncThunk(
    'bmr/fetchAllLocation',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/location');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// add Location
export const addLocation = createAsyncThunk(
    'bmr/addLocation',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.post('/location/create', args);
            notify.success(response.data.message);
            dispatch(disableAddModal())
            dispatch(fetchAllLocation());
            return response.data;
        } catch (error) {
            notify.error(error || error.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// edit location
export const editLocation = createAsyncThunk(
    'bmr/editLocation',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { data, editId } = args;
            const response = await api.put(`/location/update/${editId}`, data);
            notify.success(response.data.message);
            dispatch(disableAddModal())
            dispatch(fetchAllLocation());
            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
// delete location
export const deleteLocation = createAsyncThunk(
    'bmr/deleteLocation',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { id } = args;
            const response = await api.delete(`/location/${id}`);
            notify.success(response.data.message);
            dispatch(fetchAllLocation());
            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

const bmrLocationSlice = createSlice({
    name: 'bmrLocation',
    initialState,
    reducers: {
        enableAddModal(state) {
            state.addModal = true
        },
        disableAddModal(state) {
            state.addModal = false
        },
    },
    extraReducers: (builder) => {
        /// handle fetch all primary diagnosis list
        builder
            .addCase(fetchAllLocation.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllLocation.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allLocation = action.payload.data
            })
            .addCase(fetchAllLocation.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle add location
        builder
            .addCase(addLocation.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addLocation.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(addLocation.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle edit location
        builder
            .addCase(editLocation.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(editLocation.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(editLocation.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle delete location
        builder
            .addCase(deleteLocation.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteLocation.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteLocation.rejected, (state) => {
                state.isLoading = false;
            });
    },
});
export const { disableAddModal, enableAddModal } = bmrLocationSlice.actions

export const selectLocationLoading = (state) => state.bmrLocation.isLoading;
export const selectLocationAll = (state) => state.bmrLocation.allLocation;
export const selectBmrAddModal = (state) => state.bmrLocation.addModal









export default bmrLocationSlice.reducer;
